export const QuarantineActionType = {
  FETCH_QUARANTINE_MESSAGES: 'FETCH_QUARANTINE_MESSAGES',
  SET_QUARANTINE_MESSAGES: 'SET_QUARANTINE_MESSAGES',
  ACKNOWLEDGE_QUARANTINE_MESSAGE: 'ACKNOWLEDGE_QUARANTINE_MESSAGE',
  CLEAR_QUARANTINE_MESSAGE: 'CLEAR_QUARANTINE_MESSAGE',
  SET_LOADING: 'SET_LOADING',
  RESET_STATE: 'RESET_STATE',
};

export interface DocumentQuarantineMessage {
  policyNumber: string;
  accountNumber: string;
  uploadDate: string;
  fileName: string;
  contentId: string;
}

export const fetchQuarantineMessages = () => ({
  type: QuarantineActionType.FETCH_QUARANTINE_MESSAGES,
});

export const setLoading = (isLoading: boolean) => ({
  type: QuarantineActionType.SET_LOADING,
  payload: {isLoading},
});

export const resetState = () => ({
  type: QuarantineActionType.RESET_STATE,
});

export const acknowledgeQuarantineMessage = (contentId: string) => ({
  type: QuarantineActionType.ACKNOWLEDGE_QUARANTINE_MESSAGE,
  payload: {contentId},
});

interface QuarantineState {
  messages: DocumentQuarantineMessage[];
  acknowledged: boolean;
  isLoaded: boolean;
  isLoading: boolean;
}

const initialState: QuarantineState = {
  messages: [],
  isLoaded: false,
  acknowledged: false,
  isLoading: false,
};

export default function quarantineReducer(state = initialState, action: any) {
  switch (action.type) {
    case QuarantineActionType.SET_QUARANTINE_MESSAGES:
      return {
        ...state,
        messages: action.payload.messages,
        isLoaded: true,
        isLoading: false,
      };
    case QuarantineActionType.CLEAR_QUARANTINE_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter(msg => msg.contentId !== action.payload.contentId),
        acknowledged: true,
        isLoading: false,
      };
    case QuarantineActionType.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case QuarantineActionType.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
